import type { ReactNodeViewProps } from '@tiptap/react';
import { NodeViewWrapper } from '@tiptap/react';
import { PlaceholderChip } from './placeholderNodes.styles';
import type { PlaceholderExtensionOptions } from './placeholderNodes';

export const SelectionListPlaceholder = ({
  node,
  getPos,
  selected,
  extension,
}: ReactNodeViewProps) => {
  const name = node.attrs.name as string;
  const { onActivateList } = extension.options as PlaceholderExtensionOptions;

  const handleActivate = () => {
    const pos = getPos();
    if (pos !== undefined) onActivateList(pos);
  };

  return (
    <NodeViewWrapper as="span" data-ph-no-autocapture>
      <PlaceholderChip
        $active={selected}
        role="button"
        aria-label={name}
        tabIndex={-1}
        // onMouseDown + preventDefault keeps the editor selection intact through the click.
        onMouseDown={(event) => {
          event.preventDefault();
          handleActivate();
        }}
      >
        {`[${name}]`}
      </PlaceholderChip>
    </NodeViewWrapper>
  );
};
